// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2PYI4","range":"MonthRangeSwitch_range__3rqVd","disabled":"MonthRangeSwitch_disabled__1iVq3"};